import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';
import { Autocomplete } from '@mui/material';
import Header from '../components/Header';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { useFormik } from "formik";
import dayjs from "dayjs";
import { Paper } from '@mui/material';
import { styled } from '@mui/material';
import { Button } from '@mui/material';
import { Divider } from '@mui/material';
import { toast } from 'sonner';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { Tooltip } from '@mui/material';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import PaymentIcon from '@mui/icons-material/Payment';
import { Modal } from '@mui/material';
import { Chip } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    border: '3px',
    borderColor:'grey',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    marginBottom: '30px',
    minHeight:'50px',
    borderRadius:'10px'
  }));

const Stocks = () => {
    const location = useLocation();
    const society_id = location.state && location.state.society_id;
    const society_name = location.state && location.state.name;
    const [stock_data, setStock_data] = useState([]);
    const [stock_item, setStock_item] = useState([]);
    const [stock_item_check, setStock_item_check] = useState(false);
    const [open_assign, setOpen_assign] = useState(false)
    const [open_register, setOpen_register] = useState(false)
    const [editing_mode, setEditing_mode] = useState(false);
    const [clusters, setClusters] = useState([]);
    const [communities, setCommunities] = useState([]);
    const [groups, setGroups] = useState([]);
    const [allUsers, setAllUsers] = useState([]);

    const handleEditItem = (item) => {
        formik_register.setFieldValue('id', item.item_id)
        formik_register.setFieldValue('item_name', item.item_name)
        formik_register.setFieldValue('life_span', item.life_span)
        setOpen_register(true)
    }


    // console.log(stock_data?.logistic_items)

    const handleRegister = () => {
        setOpen_register(true);
    }

    const closeAssign = () => {
        setOpen_assign(false)
        formik.handleReset();
    }
    
    const closeRegister = () => {
        setOpen_register(false)
        formik_register.handleReset();
    }

    const formik_register = useFormik({
        initialValues: {
            id: "",
            item_name: "",
            life_span: "",
        },
        onSubmit: (values) => {
          const data = new FormData();
          data.append("item_name", values.item_name);
          data.append("life_span", values.life_span);
          if(values.id){
            data.append("id", values.id);
          }
        
          toast.promise(
              api
              .post(
                "/association/create/logistic/item",
                data,
                {
                  headers: {
                    Authorization: "Bearer " + fetchToken(),
                    "Content-Type": "multipart/form-data",
                  },
                }
              ),
              {
                  loading: 'Processing...',
                  success: (response) => {
                        closeRegister();
                        fetchStockData();

                      return response.data
                  },
                  error: (error) => {
                      console.log(error);
                      
                      return 'Error, Please try again'
                  }
              }
          )
        },
    });
    
    const formik = useFormik({
        initialValues: {
            item_id: "",
            handler_id: "",
            level: "",
            level_id: "",
            quantity: ""
        },
        onSubmit: (values) => {
          const data = new FormData();
          data.append("society_id", society_id);
          data.append("item_id", values.item_id);
          if(values.handler_id){
            data.append("handler_id", values.handler_id); 
          }
          data.append("level", values.level);
          data.append("level_id", values.level_id);
          data.append("quantity", values.quantity);
          
        
          toast.promise(
              api
              .post(
                "/association/assign/logistic",
                data,
                {
                  headers: {
                    Authorization: "Bearer " + fetchToken(),
                    "Content-Type": "multipart/form-data",
                  },
                }
              ),
              {
                  loading: !editing_mode?'Putting Item To Work...': 'Updating...',
                  success: (response) => {
                      setEditing_mode(false);
                      handleDisplayLogistic(values.item_id);
                      closeAssign()

                      return response.data
                  },
                  error: (error) => {
                      console.log(error);
                      
                      return 'Error, Please try again'
                  }
              }
          )
        },
    });



    const fetchStockData = () => {
        toast.promise(
            api.get(`/association/get/society/logistic/data/summary/${society_id}`, {
                headers: {
                    Authorization: "Bearer " + fetchToken(),
                },
            }),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setStock_data(response.data);
                    // console.log(response.data)
                    
                    return "Data Loaded successfully";
                },
                error: (error) => {
                    console.log(error);

                    return 'An error occurred, Please try again'
                }
            }
        )

        toast.promise(
            api
            .get(
              `/association/get/clusters/${society_id}`,
              {
                headers: {
                  Authorization: "Bearer " + fetchToken(),
                  "Content-Type": "multipart/form-data",
                },
              }
            ),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setClusters(response.data.all);
                    
                    return 'Data loaded successfully' 
                },
                error: (error) => {
                    console.log(error);
                    
                    return 'Error, Please try again'
                }
            }
        )

        toast.promise(
            api
            .get(
              `/association/get/groups/in/society/${society_id}`,
              {
                headers: {
                  Authorization: "Bearer " + fetchToken(),
                  "Content-Type": "multipart/form-data",
                },
              }
            ),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setGroups(response.data?.groups);
                    
                    return 'Data loaded successfully' 
                },
                error: (error) => {
                    console.log(error);
                    
                    return 'Error, Please try again'
                }
            }
        )

        toast.promise(
            api
            .get(
              `/association/get/communities/in/society/${society_id}`,
              {
                headers: {
                  Authorization: "Bearer " + fetchToken(),
                  "Content-Type": "multipart/form-data",
                },
              }
            ),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setCommunities(response.data?.communities);
                    
                    return 'Data loaded successfully' 
                },
                error: (error) => {
                    console.log(error);
                    
                    return 'Error, Please try again'
                }
            }
        )

        const data = new FormData()
        data.append('which', 0)
        data.append('society_id', society_id)

        toast.promise(
            api
            .post(`/users/user/filter`, data ,{
                headers: {
                Authorization: "Bearer " + fetchToken(),
                },
            }),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setAllUsers(response.data);

                    return "Data Loaded Successfully"
                },
                error: (error) => {
                console.log(error);

                return "An Error Occurred, Please refresh"
                }
            }
        )
    }

    useState(() => {
        fetchStockData();
    },[society_id])

    const handleDisplayLogistic = (id) => {
        const data = new FormData()
        data.append('item_id', id)
        data.append('society_id', society_id)

        toast.promise(
            api.post('/association/get/one/logistic/item', data, {
                headers: {
                    Authorization: "Bearer " + fetchToken(),
                },
            }),
            {
                loading: 'Loading Data...',
                success: (response) => {
                    setStock_item(response.data);
                    setStock_item_check(true)
                    formik.setFieldValue('item_id', response.data?.id)

                    return "Data Loaded successfully";
                },
                error: (error) => {
                    console.log(error);

                    return 'An error occurred, Please try again'
                }
            }
        )
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 900,
        maxHeight: "80vh",
        minHeight: "70vh",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "7px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#555",
        },
        bgcolor: "background.paper",
        borderRadius: "7px",
        boxShadow: 24,
        p: 4,
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });

    function formatDateToYearMonthDay(date) {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = "th";

        if (day === 1 || day === 21 || day === 31) {
            suffix = "st";
        } else if (day === 2 || day === 22) {
            suffix = "nd";
        } else if (day === 3 || day === 23) {
            suffix = "rd";
        }

        return `${day}${suffix} ${month} ${year}`;
    }


  return (
    <div className="app">
        <main className="content">
            <Box sx={{ m: 5 }}>
                <Box>
                    <Typography
                        variant="h3"
                        sx={{ textAlign: "center", m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>{society_name}</b>
                    </Typography>
                    <Typography
                        variant="h3"
                        sx={{ textAlign: "center", m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Stock Manager</b>
                    </Typography>
                </Box>
                {/* main content */}
                <Grid container spacing={2} sx={{ my:2 }}>
                    <Grid item xs={12} md={4}>
                        <Item>
                            <Typography
                                variant="h5"
                                sx={{ m: 1, textAlign: "center" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                                <b>Stock Data</b>
                            </Typography>
                            <Divider variant="middle"/>
                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Logistics: {stock_data?.total_stocks}</b>
                            </Typography>
                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Logistics Value: {currencyFormat.format(stock_data?.total_stocks_value)}</b>
                            </Typography>
                            
                            <Typography sx={{ m: 1, textAlign: "center" }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>~~</b>
                            </Typography>
                            
                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Available Logistics: {stock_data?.total_available_stocks}</b>
                            </Typography>
                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Available Logistics Value: {currencyFormat.format(stock_data?.total_available_stocks_value)}</b>
                            </Typography>
                            
                            <Typography sx={{ m: 1,textAlign: "center" }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>~~</b>
                            </Typography>

                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Logistics In Use: {stock_data?.total_stocks_inuse}</b>
                            </Typography>
                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Logistics In Use Value: {currencyFormat.format(stock_data?.total_stocks_inuse_value)}</b>
                            </Typography>
                        </Item>
                    </Grid>
                    {
                        !stock_item_check?
                            <Grid item xs={12} md={8}>
                                <Item>
                                <Chip 
                                    size='medium'
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Register Item</b></Typography>}
                                    sx={{
                                        borderRadius:2,
                                        m:1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor:'#2b2d42',
                                        color:'#fff',
                                        '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#14213d',
                                        },
                                    }} 
                                    onClick={handleRegister} 
                                />
                                <Divider />
                                    <Box
                                    sx={{
                                        overflow: "auto",
                                        marginBottom: 10,
                                        marginLeft: 2,
                                        maxHeight: 340,
                                        "&::-webkit-scrollbar": {
                                        width: "7px",
                                        height: "7px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                        background: "#f1f1f1",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                        background: "#888",
                                        borderRadius: "10px",
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                        background: "#555",
                                        },
                                    }}
                                    >
                                    <Table size="small" aria-label="logistic items table">
                                        <TableHead>
                                        <TableRow>
                                            <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>No.</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Item Name</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total Quantity</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Available</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>In Use</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total Value</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Est. Life Span</b>
                                            </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Actions</b>
                                            </Typography>
                                            </TableCell>
                                        </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {stock_data && stock_data?.logistic_items?.map((item, index) => (
                                            <TableRow
                                                key={item.item_id}
                                                sx={{
                                                    "&:last-child td, &:last-child th": { border: 0 },
                                                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f3f4",
                                                }}
                                            >
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{index + 1}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{item.item_name}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{item.total_quantity}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography 
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                color={item.total_amount_left === 0 ? "error" : "success"}
                                                >
                                                <b>{item.total_amount_left}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{item.total_inuse}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{currencyFormat.format(item.total_value)}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{item.life_span? item.life_span: 'Not Specified' }</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Box display="flex" justifyContent="center" gap={1}>
                                                <Button
                                                    size="small"
                                                    color="info"
                                                    variant="contained"
                                                    sx={{
                                                    borderRadius: 2,
                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                    }}
                                                    onClick={() => handleDisplayLogistic(item.item_id)}
                                                >
                                                    <VisibilityRoundedIcon fontSize="small" />
                                                </Button>
                                                <Button
                                                    size="small"
                                                    color="success"
                                                    variant="contained"
                                                    sx={{
                                                    borderRadius: 2,
                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                    }}
                                                    onClick={() => handleEditItem(item)}
                                                >
                                                    <EditNoteRoundedIcon fontSize="small" />
                                                </Button>
                                                </Box>
                                            </TableCell>
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                    </Box>
                                </Item>
                            </Grid>:null
                    }
                    {
                        stock_item_check?
                            <Grid item xs={12} md={8}>
                                <Item>
                                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Box>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                sx={{
                                                    borderRadius: 2,
                                                    backgroundColor: "#000",
                                                    color: "#fff",
                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                }}
                                                onClick={() => setStock_item_check(false)}
                                            >
                                                <ArrowBackRoundedIcon fontSize="medium" />
                                            </Button>
                                        </Box>
                                        <Box>
                                            <Typography
                                                variant="h5"
                                                sx={{ m: 1, textAlign: "center" }}
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            >
                                                <b>{stock_item?.name}</b>
                                            </Typography>
                                            <Typography
                                                variant="subtitle"
                                                sx={{ m: 1, textAlign: "center" }}
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            >
                                                <b>{stock_item?.life_span}</b>
                                            </Typography>
                                        </Box>
                                        <Box></Box>
                                    </Box>
                                    

                                    <Divider variant='middle' sx={{ m:1 }} />

                                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Box>
                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total {stock_item?.name}: {stock_item?.total_stocks}</b>
                                            </Typography>
                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total {stock_item?.name} Value: {currencyFormat.format(stock_item?.total_stocks_value)}</b>
                                            </Typography>
                                            
                                            <Typography sx={{ m: 1, textAlign: "center" }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>~~</b>
                                            </Typography>
                                                
                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total Available {stock_item?.name}: {stock_item?.total_available_stocks}</b>
                                            </Typography>
                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total Available {stock_item?.name} Value: {currencyFormat.format(stock_item?.total_available_stocks_value)}</b>
                                            </Typography>
                                            
                                            <Typography sx={{ m: 1,textAlign: "center" }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>~~</b>
                                            </Typography>

                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total {stock_item?.name} In Use: {stock_item?.total_stocks_inuse}</b>
                                            </Typography>
                                            <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total {stock_item?.name} In Use Value: {currencyFormat.format(stock_item?.total_stocks_inuse_value)}</b>
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Button
                                                onClick={() => setOpen_assign(true)}
                                                variant="contained"
                                                size="medium"
                                                sx={{
                                                    borderRadius: 2,
                                                    m: 1,
                                                    backgroundColor: "#000",
                                                    color: "#fff",
                                                    boxShadow:
                                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow:
                                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                }}
                                            >
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Manual Assignment</b>
                                                </Typography>
                                            </Button>
                                        </Box>
                                        
                                    </Box>

                                    <Box
                                        sx={{
                                            overflow: "auto",
                                            marginBottom: 10,
                                            marginLeft: 2,
                                            maxHeight: 340,
                                            "&::-webkit-scrollbar": {
                                            width: "7px",
                                            height: "7px",
                                            },
                                            "&::-webkit-scrollbar-track": {
                                            background: "#f1f1f1",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                            background: "#888",
                                            borderRadius: "10px",
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                            background: "#555",
                                            },
                                        }}
                                        >
                                        <Table size="small" aria-label="stock transaction table">
                                            <TableHead>
                                            <TableRow>
                                                <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Date</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Transaction Type</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Quantity In</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Quantity Out</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Balance</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Assigned To</b>
                                                </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Value</b>
                                                </Typography>
                                                </TableCell>
                                            </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {stock_item?.item_records?.slice().reverse().map((record, index) => (
                                                <TableRow
                                                key={index}
                                                sx={{
                                                    "&:last-child td, &:last-child th": { border: 0 },
                                                    backgroundColor: record.type === "Stock Addition" ? "#f0f8ff" : "#fff8f0",
                                                }}
                                                >
                                                <TableCell align="left">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{formatDateToYearMonthDay(new Date(record.date))}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{record.type}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{record.quantity_in > 0 ? record.quantity_in : "-"}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{record.quantity_out > 0 ? record.quantity_out : "-"}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{record.balance}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{record.assigned_to ? `${record.assigned_to} (${record.handler || 'No handler'})` : "-"}</b>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{record.type === "Stock Addition" 
                                                            ? `+${currencyFormat.format(record.value_in)}` 
                                                            : record.type === "Stock Assignment" 
                                                            ? `-${currencyFormat.format(record.value_out)}` 
                                                            : "-"}</b>
                                                    </Typography>
                                                </TableCell>
                                                </TableRow>
                                            ))}
                                            </TableBody>
                                        </Table>
                                        </Box>
                                </Item>
                            </Grid>
                        :null
                    }
                    
                </Grid>


                <Modal
                    open={open_register}
                    onClose={closeRegister}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <Typography
                                    variant="h5"
                                    sx={{ m: 1, textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>{formik_register.values.id?'Update Item':'Register New Item'}</b>
                                </Typography>
                                <Divider />
                                <TextField
                                    sx={{ m:1 }}
                                    required
                                    size="small"
                                    name="item_name"
                                    value={formik_register.values.item_name}
                                    onChange={formik_register.handleChange}
                                    placeholder="Tablets"
                                    helperText="Item name"
                                    fullWidth
                                />
                                <TextField
                                    sx={{ m:1 }}
                                    size="small"
                                    name="life_span"
                                    value={formik_register.values.life_span}
                                    onChange={formik_register.handleChange}
                                    placeholder="2 Years"
                                    helperText="Estimated life span (Optional)"
                                    fullWidth
                                />

                                <Box sx={{ display:'flex', flexDirection:'row' }}>
                                    <Button
                                        size="small"
                                        color="error"
                                        variant="contained"
                                        sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                        }}
                                        onClick={closeRegister}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        size="small"
                                        color="success"
                                        variant="contained"
                                        sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                        }}
                                        onClick={formik_register.handleSubmit}
                                    >
                                        {formik_register.values.id? 'Update':'Register'}
                                    </Button>
                                </Box>
                            </Grid> 
                        </Grid>
                    </Box>
                </Modal>

                <Modal
                    open={open_assign}
                    onClose={closeAssign}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <Typography
                                    variant="h5"
                                    sx={{ m: 1, textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>Put Item To Work</b>
                                </Typography>

                                <Divider />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    id="tags-outlined"
                                    options={[{'id': 'society', 'value': 'Society'}, {'id': 'cluster', 'value': 'Cluster'}, {'id': 'community', 'value': 'Community'}, {'id': 'association', 'value': 'Savings Group'}]}
                                    sx={{ mt: 2 }}
                                    getOptionLabel={(option) => option.value}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value.id
                                    }
                                    onChange={(event, value) => {
                                            formik.setFieldValue("level", value.id)
                                            if(value.id === 'society'){
                                                formik.setFieldValue("level_id", society_id)
                                            }
                                        }
                                    }
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        helperText="Item Accessibility Level"
                                        size="small"
                                        fullWidth
                                    />
                                    )}
                                />

                                {
                                    formik.values.level && formik.values.level !== 'society' ?
                                        <Autocomplete
                                            id="tags-outlined"
                                            options={formik.values.level === 'cluster'?clusters: formik.values.level === 'community'?communities:groups}
                                            sx={{ mt: 2 }}
                                            getOptionLabel={(option) => formik.values.level === 'cluster'?option.cluster_name: formik.values.level === 'community'?option.community_name:option.association_name}
                                            isOptionEqualToValue={(option, value) => {
                                                    const id = formik.values.level === 'cluster'? value.cluster_id: formik.values.level === 'community'?value.community_id:value.association_id
                                                    option.value === id
                                                }
                                            }
                                            onChange={(event, value) => {
                                                    const id = formik.values.level === 'cluster'? value.cluster_id: formik.values.level === 'community'?value.community_id:value.association_id
                                                    formik.setFieldValue("level_id", id)
                                                }
                                            }
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                helperText={`Select ${formik.values.level === 'association'?'Savings Group': formik.values.level}`}
                                                size="small"
                                                fullWidth
                                            />
                                            )}
                                        /> 
                                    :null
                                }

                                <Autocomplete
                                    id="tags-outlined"
                                    options={allUsers}
                                    sx={{ mt: 2 }}
                                    getOptionLabel={(option) => option.username}
                                    isOptionEqualToValue={(option, value) =>
                                            option.username === value.id
                                    }
                                    onChange={(event, value) => 
                                            formik.setFieldValue("handler_id", value.id)
                                    }
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        helperText='Select Worker assigned to (not required)'
                                        size="small"
                                        fullWidth
                                    />
                                    )}
                                /> 

                                <TextField
                                    sx={{ m:1 }}
                                    size="small"
                                    name="quantity"
                                    type='number'
                                    value={formik.values.quantity}
                                    onChange={formik.handleChange}
                                    placeholder="1"
                                    helperText="Quantity"
                                    fullWidth
                                />

                                <Box sx={{ display:'flex', flexDirection:'row' }}>
                                    <Button
                                        size="small"
                                        color="error"
                                        variant="contained"
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={closeAssign}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        size="small"
                                        color="success"
                                        variant="contained"
                                        disabled={formik.values.quantity > stock_item?.total_available_stocks}
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={formik.handleSubmit}
                                    >
                                        Complete
                                    </Button>
                                </Box> 
                            </Grid>
                            <Grid item xs={12} md={1}>

                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box sx={{m:'auto'}}>
                                    <Item>
                                        <Typography
                                            variant="h2"
                                            sx={{ m: 1, textAlign: "center" }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>In Stock: {stock_item?.total_available_stocks}</b>
                                        </Typography>
                                        {
                                            formik.values.quantity > stock_item?.total_available_stocks?
                                                <Typography
                                                    variant="subtitle"
                                                    sx={{ m: 1, textAlign: "center", color:'red' }}
                                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                    <b>Not enough items in stock</b>
                                                </Typography>
                                            :null
                                        }
                                        
                                        <Typography
                                            variant="h6"
                                            sx={{ m: 1, textAlign: "center" }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>Value: {currencyFormat.format(stock_item?.total_available_stocks_value)}</b>
                                        </Typography>
                                    </Item>
                                </Box>
                            </Grid>
                        </Grid>
                        

                    </Box>
                </Modal>

            </Box>
        </main>
    </div>
  )
}

export default Stocks